/* separator-line.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./separator-line.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Box } from '@atlaskit/primitives/compiled';
var styles = {
  line: "_4t3it94y _1bsb1osq _bfhk18j9"
};
export var SeparatorLine = function SeparatorLine() {
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.line
  });
};